const en = {
    "home.header.title": "Unlimited movies, TV shows, and more",
    "home.header.subtitle": "Watch anywhere. Cancel anytime.",
    "home.header.cta": "Ready to watch? Enter your email to create or restart your membership.",
    "home.button.started":"Get Started",
    "home.main.tv": "Enjoy on your TV",
    "home.main.tvsubtitle":"Watch on Smart TVs, Playstation, Xbox, Chromecast, Apple TV, Blu-ray players, and more.",
    "home.main.phone":"Download your shows to watch offline",
    "home.main.phonesubtitle":"Save your favorites easily and always have something to watch.",
    "home.main.lowertv":"Watch everywhere", 
    "home.main.lowertvsubtitles":"Stream unlimited movies and TV shows on your phone, tablet, laptop, and TV.",
    "home.main.kids":"Create profiles for kids",
    "home.main.kidssubtitle":"Send kids on adventures with their favorite characters in a space made just for them—free with your membership.",
    "home.footer.question":"Frequently Asked Questions",
    
    "question1":"What is netflix",
    "answer1":
    `<h1>Netflix is a streaming service that offers a wide variety of
    award-winning TV shows,
    movies, anime, documentaries, and more on thousands of internet-connected devices.
   <br>
   <br>
   You can watch as much as you want, whenever you want without a single commercial
    – all for one low monthly price. Theres always something new to discover and new 
    TV shows and movies are added every week! </h1>`,

    "question2":"How much does Netflix cost?",
    "answer2":`<h1 >Watch Netflix on your smartphone, tablet, Smart TV, laptop,
    or streaming device, all for one fixed monthly fee. Plans range from EUR9.39
     to EUR13.99 a month. No extra costs, no contracts. </h1>`,

     "question3":"Where Can I Watch",
     "answer3":`<h1 >Watch anywhere, anytime. Sign in with your Netflix account to
     watch instantly on the web at netflix.com from your personal computer or
      on any internet-connected device that offers the Netflix app, including
       smart TVs, smartphones, tablets, streaming media players and game consoles.
<br/>
<br/>
    You can also download your favorite shows with the iOS, Android, or Windows 10 app. Use downloads to watch while youre on the go and without an internet connection. Take Netflix with you anywhere. </h1>`,

    "question4":"How do I cancel?",
    "answer4":`<h1>Netflix is flexible. There are no pesky contracts
    and no commitments. You can easily cancel your account 
    online in two clicks. There are no cancellation fees
     – start or stop your account anytime.</h1>`,

     "question5":"What can I watch on Netflix?",
     "answer5":`<h1>Netflix has an extensive library of feature films,
     documentaries, TV shows, anime, award-winning Netflix originals,
      and more. Watch as much as you want, anytime you want.</h1>`,

      "question6":"Is Netflix good for kids?",
      "answer6":`<h1>The Netflix Kids experience is included in your 
      membership to give parents control while kids enjoy family-friendly
       TV shows and movies in their own space.
      <br/>
      <br/>
Kids profiles come with PIN-protected parental controls that let you restrict
the maturity rating of content kids can watch and block specific titles you 
don’t want kids to see.</h1>`,

    "question7":"Why am I seeing this language?",
    "answer7":`<h1>Your browser preferences determine the language shown here.</h1>`,

    "ready":"Ready to watch? Enter your email to create or restart your membership."
}
export default en